export * from './additional-config/base.js';
export * from './additional-config/supagard-constants.js';
export * from './additional-config/supagard.js';
import { DTAlgoliaConfig, ProcessedAlgoliaConfig } from '@rabbit/data/types';

export const getAdditionalConfig = async (tenantLink: string) => {
  const fileName = tenantLink.toLowerCase() ?? 'base';

  try {
    return await import(`./additional-config/${fileName}.ts`);
  } catch (e) {
    console.warn(`File './additional-config/${fileName}.ts' not found`);
    return await import('./additional-config/base.js');
  }
};

/**
 * Process raw DTAlgoliaConfig into ProcessedAlgoliaConfig for use with SearchOptions
 * Now uses the simplified direct array format
 */
export function processAlgoliaConfig(
  config: DTAlgoliaConfig
): ProcessedAlgoliaConfig {
  return {
    tenantLink: config.tenantLink,
    description: config.description,
    searchableAttributes: config.searchableAttributes || [],
    attributesToRetrieve: config.attributesToRetrieve || [],
    sorting: config.sorting || {},
    filters: config.filters || {},
    searchSettings: config.searchSettings || {
      hitsPerPage: 1000,
      typoTolerance: false,
    },
    version: config.version,
  };
}
